require("./components/bootstrap");
import mixin from "./components/mixin.js";
import Axios from "axios";
import { AutoScroll } from "sortablejs";
var product = new Vue({
    el: '.storeList',
    mixins: [mixin],
    data: {
        branchListdistricted: [],
        branchListPaged: [],
        curPage: 1,
        curDistrict: "All",
        pageCount: 0,
        branchList: (typeof branchList !== 'undefined') ? branchList : [],
    },




    created: function () {
        this.initPagedBranchList()
    },
    methods: {
        initPagedBranchList() {
            for (var i = 0; i < this.branchList.length; i++) {
                this.branchListdistricted.push(this.branchList[i]);
            }
            this.pagedBranchListHandler();
        },
        setPagedBranchList(index, district) {
            if(index != this.curPage && (index > 0 && index <= this.pageCount)){
                this.curPage = index;
                this.pagedBranchListHandler();
            }
        },
        
        pagedBranchListHandler() {
            $('#table-storelist').DataTable().clear().destroy();
            $('#table-storelist').DataTable( {
                autoWidth: false, 
                paging:   false,
                ordering: true,
                info:     false,
                searching: false,
                processing: true,
                pageLength: 15,
            } );
            this.branchListPaged = [];
            for (var i = 15 * (this.curPage - 1); i < this.branchListdistricted.length; i++) {
                if (this.branchListPaged.length < 15) {
                        this.branchListPaged.push(this.branchListdistricted[i]);
                        if(this.lang === "tc"){
                            var ArrayRow = [this.branchListdistricted[i].area_tc,this.branchListdistricted[i].name_tc + " - " + this.branchListdistricted[i].address_tc ,this.branchListdistricted[i].phone_no]
                        } else {
                            var ArrayRow = [this.branchListdistricted[i].area_en,this.branchListdistricted[i].name_en + " - " + this.branchListdistricted[i].address_en ,this.branchListdistricted[i].phone_no]
                        }
                        $('#table-storelist').DataTable().row.add(ArrayRow).draw();
                        console.log('added ' + this.branchListdistricted[i].name_tc)
                }
            }
            this.getPage()
        },

        onChangeDistrict(event) {
            this.curPage = 1;
            this.branchListdistricted = [];
            this.curDistrict = event.target.value;
            for (var i = 0; i < this.branchList.length; i++) {
                if(this.branchList[i].district_tc == this.curDistrict || this.branchList[i].district_en == this.curDistrict || this.curDistrict == 'All'){
                    this.branchListdistricted.push(this.branchList[i]);
                }
            }
            this.pagedBranchListHandler();
        },

        getPage() {

            this.pageCount = Math.ceil(this.branchListdistricted.length / 15)
        },

        
    }
})
